import type { enStokInsights } from '../en/stok-insights';

export const idStokInsights: Record<keyof typeof enStokInsights, string> = {
  // ---- Detail pemasok -------------------------------------------------------------------
  'stok.supplierIntel.title': 'Pemasok',
  'stok.supplierIntel.subtitle':
    'Data pemasok, kinerja, dan harga dari dokumen yang sudah diposting di {branch}.',
  'stok.supplierIntel.back': 'Semua pemasok',
  'stok.supplierIntel.open': 'Buka pemasok {name}',
  'stok.supplierIntel.notFound': 'Pemasok ini tidak ada atau sudah tidak tersedia.',
  'stok.supplierIntel.factsTitle': 'Data pemasok',
  'stok.supplierIntel.factsDesc': 'Data master yang dipakai bersama semua cabang.',
  'stok.supplierIntel.noAccess':
    'Kinerja, harga, dan penilaian memerlukan izin baca pengadaan untuk cabang ini.',
  'stok.supplierIntel.window': 'Periode analisis',
  'stok.supplierIntel.windowDays': '{days} hari',
  'stok.supplierIntel.windowNote':
    '{from} – {to} (tanggal bisnis). Berlaku untuk kartu skor, harga, dan perbandingan.',
  'stok.supplierIntel.range': '{from} – {to}',

  // ---- Kartu skor -----------------------------------------------------------------------
  'stok.supplierIntel.scorecardTitle': 'Kartu skor',
  'stok.supplierIntel.scorecardDesc':
    'Rasio dari PO, penerimaan, dan faktur yang sudah diposting di cabang ini, masing-masing dengan jumlah sampelnya.',
  'stok.supplierIntel.scoreLabel': 'Skor keseluruhan',
  'stok.supplierIntel.scoreValue': '{score} / 100',
  'stok.supplierIntel.scoreHint': 'Rata-rata berbobot dari empat metrik yang dinilai.',
  'stok.supplierIntel.insufficient': 'Data belum cukup',
  'stok.supplierIntel.noScore':
    'Belum ada skor keseluruhan: sampel terlalu sedikit untuk {metrics}. Skor muncul setelah semua metrik yang dinilai punya cukup data.',
  'stok.supplierIntel.weightsTitle': 'Bobot yang dipakai',
  'stok.supplierIntel.weightsDesc':
    'Kualitas = 100% − tingkat penolakan; akurasi faktur = 100% − tingkat selisih. Selisih harga ditampilkan tetapi tidak dinilai.',
  'stok.supplierIntel.weight.fill_rate': 'Pemenuhan',
  'stok.supplierIntel.weight.on_time': 'Tepat waktu',
  'stok.supplierIntel.weight.quality': 'Kualitas',
  'stok.supplierIntel.weight.invoice_accuracy': 'Akurasi faktur',
  'stok.supplierIntel.volumes':
    '{pos} PO · {receipts} penerimaan · {invoices} faktur · nilai diterima',
  'stok.supplierIntel.metricsLabel': 'Metrik kartu skor',
  'stok.supplierIntel.metric.fill_rate': 'Tingkat pemenuhan',
  'stok.supplierIntel.metric.fill_rateDesc': 'Bagian nilai pesanan yang benar-benar dikirim.',
  'stok.supplierIntel.metric.on_time': 'Pengiriman tepat waktu',
  'stok.supplierIntel.metric.on_timeDesc':
    'Penerimaan pada atau sebelum tanggal yang diharapkan di PO.',
  'stok.supplierIntel.metric.rejection_rate': 'Tingkat penolakan',
  'stok.supplierIntel.metric.rejection_rateDesc':
    'Bagian nilai kiriman yang ditolak saat penerimaan.',
  'stok.supplierIntel.metric.price_variance': 'Selisih harga',
  'stok.supplierIntel.metric.price_varianceDesc':
    'Harga faktur dibanding harga PO (positif = ditagih di atas PO).',
  'stok.supplierIntel.metric.invoice_discrepancy': 'Selisih faktur',
  'stok.supplierIntel.metric.invoice_discrepancyDesc':
    'Faktur PO yang pencocokan tiga arahnya berakhir sebagai pengecualian.',
  'stok.supplierIntel.samples': '{count} sampel',
  'stok.supplierIntel.samplesShort': '{count} sampel — perlu minimal {min}',
  'stok.supplierIntel.formula': 'Cara menghitung',
  'stok.supplierIntel.formulaServer': 'Definisi server:',
  'stok.supplierIntel.formula.fill_rate':
    'Σ qty diterima × harga PO ÷ Σ qty dipesan × harga PO, dari PO selesai yang dibuat dalam periode. Sampel = baris PO.',
  'stok.supplierIntel.formula.on_time':
    'Penerimaan terposting pada atau sebelum tanggal yang diharapkan ÷ penerimaan terposting untuk PO yang punya tanggal harapan. Sampel = penerimaan.',
  'stok.supplierIntel.formula.rejection_rate':
    'Σ qty ditolak × harga ÷ Σ qty dikirim × harga pada baris penerimaan terposting. Sampel = baris penerimaan.',
  'stok.supplierIntel.formula.price_variance':
    'Σ (harga faktur − harga PO) × qty faktur ÷ Σ harga PO × qty faktur pada baris faktur terposting yang cocok. Sampel = baris.',
  'stok.supplierIntel.formula.invoice_discrepancy':
    'Faktur PO terposting yang pencocokannya pengecualian (disetujui atau tidak) ÷ faktur PO terposting. Sampel = faktur.',

  // ---- Riwayat harga --------------------------------------------------------------------
  'stok.supplierIntel.pricesTitle': 'Riwayat harga',
  'stok.supplierIntel.pricesDesc':
    'Harga bersih per kg, liter, atau buah di setiap penerimaan terposting, dinormalkan dari satuan beli.',
  'stok.supplierIntel.pricesEmpty':
    'Belum ada penerimaan terposting dari pemasok ini dalam periode — harga muncul setelah barang diterima.',
  'stok.supplierIntel.priceUnit': 'Harga bersih per {unit}',
  'stok.supplierIntel.col.receipt': 'Penerimaan',
  'stok.supplierIntel.col.pricePer': 'Harga per {unit}',
  'stok.supplierIntel.chartLabel':
    'Harga {item} per {unit} dari {from} sampai {to}: terendah {min}, tertinggi {max}, terakhir {last}.',
  'stok.supplierIntel.chartKeyboard':
    'Grafik harga {item}. Gunakan tombol panah untuk membaca setiap penerimaan.',
  'stok.supplierIntel.chartHint': 'Arahkan atau fokuskan grafik untuk membaca satu penerimaan.',
  'stok.supplierIntel.chartPoint': '{date} · {receipt} · {price} per {unit}',
  'stok.supplierIntel.chartMax': 'Tertinggi {price}',
  'stok.supplierIntel.chartMin': 'Terendah {price}',

  // ---- Perbandingan ---------------------------------------------------------------------
  'stok.supplierIntel.compareTitle': 'Bandingkan pemasok',
  'stok.supplierIntel.compareDesc':
    'Semua pemasok yang mengirim barang ini ke cabang dalam periode, dengan harga per satuan tampilan.',
  'stok.supplierIntel.compareItem': 'Barang',
  'stok.supplierIntel.compareItemPick': 'Pilih barang',
  'stok.supplierIntel.compareNoItem': 'Pilih barang untuk membandingkan pemasoknya.',
  'stok.supplierIntel.compareEmpty':
    'Belum ada penerimaan terposting untuk {item} dalam periode — perbandingan muncul setelah barang diterima.',
  'stok.supplierIntel.cheapestSummary': 'Termurah rata-rata: {name}, per {unit}',
  'stok.supplierIntel.cheapestInsufficient':
    'Berdasarkan terlalu sedikit penerimaan — periksa dulu sebelum memutuskan.',
  'stok.supplierIntel.cheapest': 'Termurah',
  'stok.supplierIntel.thisSupplier': 'Pemasok ini',
  'stok.supplierIntel.col.supplier': 'Pemasok',
  'stok.supplierIntel.col.avgPer': 'Rata-rata per {unit}',
  'stok.supplierIntel.col.lastPer': 'Terakhir per {unit}',
  'stok.supplierIntel.col.receipts': 'Penerimaan (sampel)',
  'stok.supplierIntel.col.receivedQty': 'Qty diterima',
  'stok.supplierIntel.col.rejection': 'Ditolak',
  'stok.supplierIntel.col.lastReceived': 'Tanggal harga terakhir',

  // ---- Penilaian ------------------------------------------------------------------------
  'stok.supplierIntel.ratingsTitle': 'Penilaian',
  'stok.supplierIntel.ratingsDesc': 'Penilaian bulanan tim pembelian, beserta buktinya.',
  'stok.supplierIntel.ratingsEmpty':
    'Belum ada penilaian — tambahkan di akhir bulan untuk mencatat kinerja pemasok.',
  'stok.supplierIntel.ratingReadOnly': 'Menambah penilaian memerlukan izin kelola pengadaan.',
  'stok.supplierIntel.ratingAdd': 'Tambah penilaian',
  'stok.supplierIntel.ratingAddTitle': 'Nilai {name}',
  'stok.supplierIntel.ratingAddDesc':
    'Penilaian disimpan dengan nama Anda dan tidak bisa diubah sesudahnya.',
  'stok.supplierIntel.ratingSubmit': 'Simpan penilaian',
  'stok.supplierIntel.ratingSaved': 'Penilaian {period} disimpan.',
  'stok.supplierIntel.ratingPeriod': 'Periode {period}',
  'stok.supplierIntel.ratingScore': '{score} / 5',
  'stok.supplierIntel.ratingEvidence': 'Bukti: {evidence}',
  'stok.supplierIntel.ratingBy': 'Oleh {name} · {at}',
  'stok.supplierIntel.field.period': 'Periode',
  'stok.supplierIntel.field.periodHint': 'Bulan yang dinilai (YYYY-MM).',
  'stok.supplierIntel.field.score': 'Skor',
  'stok.supplierIntel.field.scoreHint': '1 = sangat buruk, 5 = sangat baik.',
  'stok.supplierIntel.field.scorePick': 'Pilih skor',
  'stok.supplierIntel.field.comment': 'Komentar',
  'stok.supplierIntel.field.commentHint': 'Apa yang berjalan baik atau buruk (3–500 karakter).',
  'stok.supplierIntel.field.evidence': 'Bukti',
  'stok.supplierIntel.field.evidenceHint': 'Nomor dokumen, foto, atau catatan yang mendukung skor.',
  'stok.supplierIntel.score.5': '5 — Sangat baik',
  'stok.supplierIntel.score.4': '4 — Baik',
  'stok.supplierIntel.score.3': '3 — Cukup',
  'stok.supplierIntel.score.2': '2 — Buruk',
  'stok.supplierIntel.score.1': '1 — Sangat buruk',
  'stok.supplierIntel.err.period': 'Isi bulan dengan format YYYY-MM.',
  'stok.supplierIntel.err.score': 'Pilih skor 1 sampai 5.',
  'stok.supplierIntel.err.comment': 'Tulis komentar minimal 3 karakter.',

  // ---- Recall: daftar dan pencarian -----------------------------------------------------
  'stok.recall.title': 'Recall',
  'stok.recall.subtitle':
    'Temukan lot yang terdampak di {branch}, blokir, dan telusuri ke mana perginya.',
  'stok.recall.readOnly':
    'Anda bisa mencari dan memantau kasus. Membuka atau menutup recall memerlukan izin persetujuan inventaris.',
  'stok.recall.searchTitle': 'Cari lot',
  'stok.recall.searchDesc':
    'Cari berdasarkan kode lot (awalan), pemasok, atau barang. Lot yang sudah habis ikut ditampilkan untuk penelusuran.',
  'stok.recall.searchBy': 'Cari berdasarkan',
  'stok.recall.mode.lot_code': 'Kode lot',
  'stok.recall.mode.supplier': 'Pemasok',
  'stok.recall.mode.item': 'Barang',
  'stok.recall.field.lot_code': 'Kode lot',
  'stok.recall.field.item': 'Barang',
  'stok.recall.pick': 'Pilih…',
  'stok.recall.search': 'Cari',
  'stok.recall.err.search': 'Isi kode lot atau pilih pemasok atau barang.',
  'stok.recall.searchIdle': 'Cari untuk melihat lot yang cocok beserta stok per lokasinya.',
  'stok.recall.searchEmpty':
    'Tidak ada lot yang cocok — periksa kode lot atau coba pemasok atau barang.',
  'stok.recall.resultCount': '{count} lot ditemukan',
  'stok.recall.selectedCount': '{count} dari {total} lot dipilih',
  'stok.recall.oneItemHint':
    'Satu kasus recall hanya untuk lot dari satu barang: setelah lot pertama, hanya lot barang yang sama yang bisa dipilih.',
  'stok.recall.selectLot': 'Pilih lot {code}',
  'stok.recall.otherItem': 'Barang lain — buka kasus terpisah untuknya.',
  'stok.recall.usedUp': 'Sudah habis',
  'stok.recall.openCase': 'Buka kasus recall',
  'stok.recall.col.select': 'Pilih',
  'stok.recall.col.onHand': 'Stok ada',
  'stok.recall.col.case': 'Kasus',
  'stok.recall.col.lots': 'Lot',
  'stok.recall.col.owner': 'Penanggung jawab',
  'stok.recall.col.openedAt': 'Dibuka',
  'stok.recall.casesTitle': 'Kasus recall',
  'stok.recall.casesDesc': 'Kasus di cabang ini, terbaru di atas.',
  'stok.recall.casesFilter': 'Status kasus',
  'stok.recall.filter.open': 'Terbuka',
  'stok.recall.filter.closed': 'Ditutup',
  'stok.recall.filter.all': 'Semua',
  'stok.recall.casesEmptyOpen': 'Tidak ada kasus recall terbuka. Buka dari pencarian lot di atas.',
  'stok.recall.casesEmpty': 'Belum ada kasus recall di sini.',
  'stok.recall.status.open': 'Terbuka',
  'stok.recall.status.closed': 'Ditutup',

  // ---- Recall: buka ---------------------------------------------------------------------
  'stok.recall.openTitle': 'Buka kasus recall',
  'stok.recall.openDesc': 'Mencatat alasan lot ditarik dan siapa yang menindaklanjuti kasus.',
  'stok.recall.selectedSummary': '{count} lot {item}',
  'stok.recall.blockWarning':
    'Lot terpilih langsung diblokir begitu kasus dibuka: tidak dipakai FEFO, tidak dikonsumsi, dan tidak bisa ditransfer.',
  'stok.recall.field.title': 'Judul',
  'stok.recall.field.titleHint': 'Nama singkat, mis. pemberitahuan pemasok (3–120 karakter).',
  'stok.recall.field.reason': 'Alasan',
  'stok.recall.field.reasonHint': 'Apa masalah lot ini dan dari mana pemberitahuannya.',
  'stok.recall.field.owner': 'Penanggung jawab',
  'stok.recall.field.ownerHint': 'Siapa yang menindaklanjuti kasus. Bawaan: Anda.',
  'stok.recall.field.ownerSelfOnly':
    'Anda penanggung jawab kasus (memilih orang lain memerlukan akses staf).',
  'stok.recall.field.ownerMe': 'Saya ({name})',
  'stok.recall.field.supplier': 'Pemasok',
  'stok.recall.field.noSupplier': 'Tanpa pemasok',
  'stok.recall.openSubmit': 'Buka kasus dan blokir lot',
  'stok.recall.opening': 'Membuka…',
  'stok.recall.opened': 'Kasus recall {number} dibuka.',
  'stok.recall.err.title': 'Isi judul minimal 3 karakter.',
  'stok.recall.err.reason': 'Isi alasan minimal 3 karakter.',

  // ---- Recall: detail -------------------------------------------------------------------
  'stok.recall.back': 'Semua recall',
  'stok.recall.detailLoading': 'Kasus recall',
  'stok.recall.detailTitle': 'Recall {number}',
  'stok.recall.factsTitle': 'Kasus',
  'stok.recall.factsDesc':
    'Siapa yang membuka, alasannya, dan siapa penanggung jawab tindak lanjut.',
  'stok.recall.fact.opened': 'Dibuka',
  'stok.recall.fact.closed': 'Ditutup',
  'stok.recall.byAt': '{name} · {at}',
  'stok.recall.impactTitle': 'Dampak per lot',
  'stok.recall.impactDesc':
    'Stok yang masih ada, dibuang, dikonsumsi pesanan, dikoreksi opname, dan ditransfer keluar.',
  'stok.recall.impactEmpty': 'Tidak ada lot di kasus ini.',
  'stok.recall.col.wasted': 'Dibuang',
  'stok.recall.col.consumed': 'Dikonsumsi',
  'stok.recall.col.counted': 'Koreksi opname',
  'stok.recall.col.transferred': 'Ditransfer',
  'stok.recall.orderItems': '{count} item pesanan',
  'stok.recall.noTransfers': 'Tidak ada',
  'stok.recall.transferTo': '→ {branch} · {qty}',
  'stok.recall.restrictedBranch': 'Cabang lain (terbatas)',
  'stok.recall.restrictedBadge': 'Tanpa akses ke cabang itu',
  'stok.recall.destinationLot': 'Diterima ke lot di sana',

  // ---- Recall: tutup --------------------------------------------------------------------
  'stok.recall.closeTitle': 'Tutup kasus',
  'stok.recall.closeDesc':
    'Tutup setelah stok ditangani. Lot tetap diblokir kecuali Anda melepasnya.',
  'stok.recall.closedNote': 'Kasus ini sudah ditutup.',
  'stok.recall.closeNeedsApprove': 'Menutup recall memerlukan izin persetujuan inventaris.',
  'stok.recall.close': 'Tutup kasus',
  'stok.recall.closeModalTitle': 'Tutup recall {number}',
  'stok.recall.field.resolution': 'Catatan penyelesaian',
  'stok.recall.field.resolutionHint':
    'Apa yang dilakukan pada stok dan siapa yang diberi tahu (3–1000 karakter).',
  'stok.recall.field.release': 'Lepaskan lot kembali menjadi tersedia',
  'stok.recall.field.releaseHint': 'Hanya bila recall dicabut, mis. pemasok membatalkannya.',
  'stok.recall.closeNext': 'Lanjut',
  'stok.recall.closeConfirm': 'Tutup recall {number}? Kasus tidak bisa dibuka kembali.',
  'stok.recall.closeReleaseWarning':
    'Lot yang ditarik kembali tersedia dan bisa dipakai, dikonsumsi, serta ditransfer.',
  'stok.recall.closeKeepNote': 'Lot tetap diblokir sebagai recall.',
  'stok.recall.closeSubmit': 'Tutup kasus',
  'stok.recall.closing': 'Menutup…',
  'stok.recall.closed': 'Kasus recall {number} ditutup.',
  'stok.recall.err.resolution': 'Isi catatan penyelesaian 3 sampai 1000 karakter.',
};
